<template>
    <v-container fluid>   
        <v-layout row wrap>   
          <v-flex xs1></v-flex>
          <v-flex xs10>
            <v-data-table
              :headers="headers"
              :items="termsComputed"
              :items-per-page="50"
              item-key="id"
              sort-by="id"
              :sort-desc=false
              class="elevation-1"
              :search="search"
              :custom-filter="filterOnlyCapsText"
              >
              <template v-slot:top>
                <v-toolbar flat color="white">
                  <v-toolbar-title>Offer Terms</v-toolbar-title>
                  <v-divider
                    class="mx-4"
                    inset
                    vertical
                  ></v-divider>
                  <v-spacer></v-spacer>
                  <v-dialog v-model="dialog" max-width="900px">
                    <template v-slot:activator="{ on }">
                      <v-btn color="primary" dark class="mb-2" v-on="on">New Offer Term</v-btn>
                    </template>
                    <v-card>
                      <v-card-title>
                        <span class="headline">{{ formTitle }}</span>
                      </v-card-title>

                      <v-card-text>
                        <v-container grid-list-md>
                          <v-layout wrap>
                            <v-flex xs12 sm6 md9>
                              <v-text-field v-model="editedItem.termName" label="Name"></v-text-field>
                            </v-flex> 
                            <v-flex xs12 sm6 md3>
                              <v-combobox
                                :items="getTermTypes()"
                                label="Term Type"
                                v-model="editedItem.termType"
                                item-text="name"
                                single-line
                                return-object
                              ></v-combobox>
                            </v-flex> 
                            <v-flex xs12 sm6 md12>
                              <v-text-field v-model="editedItem.termHeader" label="Header"></v-text-field>
                            </v-flex> 
                            <v-flex xs12 sm6 md12>
                              <v-textarea v-model="editedItem.termBody"  :outlined="true"
                              :auto-grow="true" :clearable="true"
                              label="Body"></v-textarea>
                            </v-flex>                                                                                                                                                                                                   
                          </v-layout>
                        </v-container>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="error" dark class="mb-2" @click="close">Cancel</v-btn>
                        <v-btn color="success" dark class="mb-2" @click="save">Save</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-toolbar>
                <v-text-field v-model="search" label="Search " class="mx-4"></v-text-field>
              </template> 
              <template v-slot:body.append>                    
              </template>             
              <template v-slot:item.action="{ item }">              
                <v-icon                  
                  @click="editItem(item)">
                  mdi-table-edit
                </v-icon>
                <v-icon                  
                  @click="deleteItem(item)"
                >
                  mdi-delete
                </v-icon>
              </template>
            </v-data-table>
          </v-flex>
          <v-flex xs1></v-flex>
        </v-layout>
    </v-container>
</template>
<script>
import LeftMenu from '../../components/LeftMenu';
import DatePicker from '../../components/DatePicker';
const TERMS_API_URL = 'definitions/offerTerms';
export default {
    components:{
      LeftMenu,
      DatePicker
    },
    data () {
    return {
      dialog: false,
      search: '',
      termList: [],
      editedIndex: -1,
      editedItem: {
        model: '',
          category: '',
          explanation: '', 
      },
      defaultItem: {
        model: '',
          category: '',
          explanation: '', 
      },
    }
  },
  computed: {
    headers () {
      return [
        { text: 'Type', align: 'left', sortable: true, value: 'termType'}, 
        { text: 'Name', align: 'left', sortable: true, value: 'termName'}, 
        { text: 'Header', align: 'left', sortable: true, value: 'termHeader'}, 
        { text: 'Body', align: 'left', sortable: true, value: 'shortBody'}, 
        { text: 'Operations', value: 'action', sortable: false },
      ]
    },
    termsComputed(){
      return this.termList.map((item) => {
        item.shortBody = item.termBody.substr(0,100);
        return item;  
      })
    },
    formTitle () {
      return this.editedIndex === -1 ? 'New Offer Term' : 'Edit Offer Term'
    },
  },
  created() {    
    this.getOfferTerms();   
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
  },
  methods: {
    editItem (item) {
      this.editedIndex = this.termList.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem (item) {
      const index = this.termList.indexOf(item)
      if(confirm('Are you sure you want to delete this item?')){
        this.termList.splice(index, 1);
        this.deleteOfferTerm(item);
      } 
    },
    getTermTypes(){
      return new Array("PUBLIC", "PRIVATE");
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save () {
      if (this.editedIndex > -1) {        
        this.updateOfferTerm(this.editedItem);
      } else {
        this.addOfferTerm(this.editedItem);         
      }      
    },
    addOfferTerm(item){
      this.$axios.post(this.$apiurl + TERMS_API_URL, {
        termName: item.termName,
        termHeader: item.termHeader,
        termType: item.termType,
        termBody: item.termBody
      })
      .then(response => {        
        if (response.status === 201) {
          this.termList.push(this.editedItem);
          this.getOfferTerms();   
          this.close();
          this.$emit('offerTermChanged');
        } 
      }).catch(error => {        
          console.log(error);
        }); 
    },
    updateOfferTerm(item){
      this.$axios.put(this.$apiurl + TERMS_API_URL, {
        id: item.id,
        termName: item.termName,
        termHeader: item.termHeader,
        termType: item.termType,
        termBody: item.termBody
      })
      .then(response => {
        if (response.status === 200) {
          Object.assign(this.termList[this.editedIndex], this.editedItem);
          this.close();
          this.$emit('offerTermChanged');
        }         
      }).catch(error => {        
          console.log(error);
        }); 
    },
    deleteOfferTerm(item){
      this.$axios.delete(this.$apiurl + TERMS_API_URL+'/'+item.id)
      .then(response => {
        this.$emit('offerTermChanged');
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },
    getOfferTerms(){     
        this.$axios.get(this.$apiurl + TERMS_API_URL)
            .then(response => {
                this.termList = response.data;
            }) 
            .catch(error => {
                console.log(error);
            });                         
    },
   
    filterOnlyCapsText (value, search) {
      return value != null &&
        search != null &&
        typeof value === 'string' &&
        value.toString().toLocaleUpperCase().indexOf(search.toLocaleUpperCase()) !== -1
    },
  },
}
</script>
